import {
    ArrowLeftCircle,
    InfoEmpty,
    MoreHorizCircle,
    Star,
    Trash,
} from "iconoir-react";
import { inject, observer } from "mobx-react";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertDialog from "../../components/common/AlertDialog";
import {
    EmptyText,
    RichText,
    SingleLineEllipsis,
} from "../../components/common/CellText";
import Message from "../../components/common/Message";
import FileItem from "../../components/FileItemComponent/FileItem";
import CheckLight from "../../components/image/CheckLight";
import CheckSuccessIcon from "../../components/image/CheckSuccessIcon";
import EmptyData from "../../components/image/EmptyData";
import SkeletonWorkDetail from "../../components/Skeleton/SkeletonWorkDetail";
import { getExtensionFile, getNameInCapitalize } from "../../utils/common";
import { WORK_STATUS } from "../../utils/constants";
import date_format from "../../utils/date_format";
import ContentModal from "../../components/dialog/ContentModal";
import InformationModal from "./InformationModal";
import CommentModal from "./CommentModal";
import SkeletonWorkComment from "../../components/Skeleton/SkeletonWorkComment";
import { toJS } from 'mobx';
import ListComment from "./ListComment";
import { Menu, MenuItem } from '@mui/material';

const WorkDetail = ({ workStore }) => {
    const {
        getWorkDetail,
        workDetail,
        markImportantWork,
        updateStatusWork,
        getCommentWorkList,
        commentWorkList,
        deleteCommentWork,
    } = workStore;
    const { workId } = useParams();
    const navigate = useNavigate();
    const [openContent, setOpenContent] = useState(false);
    const [openInfor, setOpenInfor] = useState(false);
    const [openCmt, setOpenCmt] = useState(false);

    const [deleteItem, setDeleteItem] = useState({
        open: false,
        id_comment: "",
    });
    const [message, setMessage] = useState({ title: "", isOpen: false });
    const [workSelect, setWorkSelect] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingCmt, setLoadingCmt] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openMore, setOpenMore] = useState(false);
    const [openCmtDel, setOpenCmtDel] = useState(false);

    const open = Boolean(anchorEl);



    const commentWorkListNotDeleted = commentWorkList?.filter(
        (item) => item.deleted !== true
    );
    const commentWorkListDeleted = commentWorkList?.filter(
        (item) => item.deleted === true
    )

    const onCommentSuccess = async () => {
        try {
            setLoadingCmt(true);
            await Promise.all([getCommentWorkList(workId)]);
        } catch (err) {
            console.log(err)
        } finally {
            setLoadingCmt(false);
        }
    }

    const getDetailWork = async () => {
        try {
            setLoading(true);
            await Promise.all([getWorkDetail(workId)]);
        } catch (err) {
            setMessage({ title: err.vi, isOpen: true });
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        (async () => {
            await Promise.all([getDetailWork(), onCommentSuccess()]);
        })();
        return () => { };
    }, [workId]);

    const handleMarkImportantWork = async (is_important) => {
        try {
            await markImportantWork(workId, is_important);
            setMessage({
                title: `Đánh dấu công việc ${is_important ? "quan trọng" : "Không quan trọng"
                    }`,
                isOpen: true,
                severity: "success",
            });
            await getWorkDetail(workId);
        } catch (err) {
            setMessage({ title: err.vi, isOpen: true, severity: "error" });
        }
    };
    const handleUpdateStatus = async (status) => {
        try {
            await updateStatusWork(workId, status);
            await getWorkDetail(workId);
            setMessage({
                title: `Đánh dấu công việc ${status === WORK_STATUS.COMPLETE
                    ? "hoàn thành"
                    : "chưa hoàn thành"
                    }`,
                isOpen: true,
                severity: "success",
            });
        } catch (err) {
            console.log(err.vi);
            setMessage({ title: err.vi, isOpen: true });
        }
    };

    const handleClickOpenInfo = () => {
        setOpenInfor(true);
    };

    const handleDeleteComment = async () => {
        setDeleteItem({ open: false, comment_id: "" });
        try {
            setLoading(true);
            await deleteCommentWork(workId, deleteItem.id_comment);
            await getCommentWorkList(workId);
        } catch (err) {
            setMessage({ title: err.vi, isOpen: true });
        } finally {
            setLoading(false);
        }
    };
    // console.log('commentWorkListNotDeleted', commentWorkListNotDeleted)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    let menu = (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                "aria-labelledby": "basic-button",
            }}
        >
            {openMore ? <MenuItem
                sx={{
                    color: "#0073C7 !important",
                    borderBottom: "1px solid rgba(0,0,0,0.05)",
                    fontSize: "12px",
                }}
                onClick={() => {
                    setOpenMore(false)
                    setOpenCmtDel(false)
                    handleClose()
                }}
            >
                <Trash
                    width={12}
                    height={14}
                    className="mr-1"
                />
                Ẩn ý kiến đã xóa
            </MenuItem> : <MenuItem
                onClick={() => {
                    setOpenMore(true)
                    setOpenCmtDel(true)
                    handleClose()
                }}
                sx={{
                    color: "#0073C7 !important",
                    borderBottom: "1px solid rgba(0,0,0,0.05)",
                    fontSize: "12px",
                }}
            >
                <Trash
                    width={12}
                    height={14}
                    className="mr-1"
                />
                Hiện ý kiến đã xóa
            </MenuItem>}



        </Menu>
    )
    return (
        <>
            <div className={`px-5 py-[20px] mb-16`}>
                {loading ? (
                    <SkeletonWorkDetail />
                ) : (
                    <>
                        <div className="flex gap-[22px]">
                            <ArrowLeftCircle
                                className="flex-shrink-0"
                                onClick={() => {
                                    navigate(-1);
                                }}
                            />
                            <span className="font-bold text-[28px] leading-[29px] text-[#28353B]">
                                {workDetail?.title}
                            </span>
                        </div>
                        {workDetail?.subwork?.length > 0 && (
                            <>
                                <div className="mt-5 text-sm font-semibold leading-5 text-labelForm">
                                    Công việc phụ:
                                </div>
                                {workDetail?.subwork?.map((item) => (
                                    <div
                                        onClick={() => {
                                            navigate(`/work/view/${item.code}`);
                                        }}
                                        className="flex items-center gap-2 p-4 mt-2 bg-itemBg rounded-xl"
                                    >
                                        <div className="w-[34px] relative  after:w-[2px] after:h-[14px] after:bg-[#E0E0E0] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2">
                                            {item.status ===
                                                WORK_STATUS.COMPLETE ? (
                                                <CheckSuccessIcon />
                                            ) : (
                                                <CheckLight />
                                            )}
                                        </div>
                                        <SingleLineEllipsis>
                                            {item?.title}
                                        </SingleLineEllipsis>
                                        <MoreHorizCircle
                                            className="text-primary"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setOpenContent(true);
                                                setWorkSelect(item);
                                            }}
                                        />
                                    </div>
                                ))}
                            </>
                        )}
                        <div className="mt-4 text-sm font-semibold leading-5 text-labelForm">
                            Trạng thái:
                        </div>
                        <div className="mt-2">
                            {workDetail?.status === WORK_STATUS.COMPLETE ? (
                                <p className="flex items-center gap-[6px]">
                                    {" "}
                                    <CheckSuccessIcon />{" "}
                                    <span className="text-sm font-normal leading-6 text-black">
                                        Hoàn thành
                                    </span>
                                </p>
                            ) : (
                                <p className="flex items-center gap-[6px]">
                                    {" "}
                                    <CheckLight />{" "}
                                    <span className="text-sm font-normal leading-6 text-black">
                                        Chưa hoàn thành
                                    </span>
                                </p>
                            )}
                        </div>
                        <div className="mt-4 text-sm font-semibold leading-5 text-labelForm">
                            Thời gian:
                        </div>
                        <div className="mt-2 text-sm font-normal leading-6 text-black">
                            Ngày giao:{" "}
                            {moment(workDetail?.start_date).format(
                                "DD/MM/YYYY"
                            )}{" "}
                            -{" "}
                            {workDetail?.due_date ? (
                                moment(workDetail.due_date).format("DD/MM/YYYY")
                            ) : (
                                <EmptyText>Không rõ</EmptyText>
                            )}
                        </div>
                        <div className="mt-4 text-sm font-semibold leading-5 text-labelForm">
                            Nội dung:
                        </div>
                        <div className="w-full overflow-hidden">
                            <RichText text={workDetail?.content} />
                        </div>
                        {workDetail?.attachments?.length > 0 && (
                            <>
                                <div className="mt-4 mb-2 text-sm font-semibold leading-5 text-labelForm">
                                    Tài liệu đính kèm:
                                </div>
                                {workDetail?.attachments.map((file) => (
                                    <FileItem
                                        file={file}
                                        key={file.file_id}
                                        file_id={file.file_id}
                                        file_name={file.file_name}
                                        file_type={getExtensionFile(
                                            file.file_name
                                        )}
                                    />
                                ))}
                            </>
                        )}
                        {commentWorkListDeleted?.length > 0 ?
                            <>
                                <div className="mt-4 text-sm flex items-center">
                                    <div className="font-semibold leading-5 text-labelForm">
                                        Danh sách ý kiến
                                    </div>
                                    <MoreHorizCircle
                                        className="text-primary ml-2"
                                        onClick={handleClick}
                                    />
                                    {menu}
                                </div>
                                {openCmtDel ?
                                    <ListComment loadingCmt={loadingCmt} commentWorkList={commentWorkListDeleted} setDeleteItem={setDeleteItem} />
                                    : ''}
                                <ListComment loadingCmt={loadingCmt} commentWorkList={commentWorkListNotDeleted} setDeleteItem={setDeleteItem} />
                            </>
                            : <>
                                {commentWorkListNotDeleted?.length > 0 && (
                                    <>
                                        <div className="mt-4 text-sm flex items-center">
                                            <div className="font-semibold leading-5 text-labelForm">
                                                Danh sách ý kiến
                                            </div>
                                            <MoreHorizCircle
                                                className="text-primary ml-2"
                                                onClick={handleClick}
                                            />
                                            {menu}
                                        </div>
                                        {openCmtDel ?
                                            <ListComment loadingCmt={loadingCmt} commentWorkList={commentWorkListDeleted} setDeleteItem={setDeleteItem} />
                                            : ''}
                                        <ListComment loadingCmt={loadingCmt} commentWorkList={commentWorkListNotDeleted} setDeleteItem={setDeleteItem} />

                                    </>
                                )}
                            </>}


                        <div
                            className="bg-[#F8F8F8] text-primary rounded-lg py-4 text-center font-semibold text-base leading-[22px] mt-2"
                            onClick={() => setOpenCmt(true)}
                        >
                            Đăng ý kiến
                        </div>
                    </>
                )}
            </div>
            <ContentModal
                open={openContent}
                handleClose={() => {
                    setOpenContent(false);
                }}
                content={workSelect?.content || workSelect?.title}
            />
            <InformationModal
                open={openInfor}
                handleClose={() => {
                    setOpenInfor(false);
                }}
                workDetail={workDetail}
            />
            <CommentModal
                open={openCmt}
                handleClose={() => {
                    setOpenCmt(false);
                }}
                workCode={workDetail.code}
                onCommentSuccess={onCommentSuccess}
            />
            <footer
                style={{
                    position: "fixed",
                    bottom: 0,
                    backgroundColor: "white",
                }}
                className="flex items-center justify-between px-5 w-full py-4 shadow-[0px_0px_8px_rgba(0,0,0,0.25)] "
            >
                <div className="flex gap-5">
                    <div
                        className=" flex w-[128px] justify-center gap-x-2 items-center  bg-[rgba(0,115,199,0.07);] py-[10px] w- text-primary px-[14px] rounded-full text-sm leading-5 cursor-pointer font-medium"
                        onClick={handleClickOpenInfo}
                    >
                        <div>
                            <InfoEmpty />
                        </div>
                        <span>Thông tin</span>
                    </div>
                    <div
                        className={`bg-[rgba(0,115,199,0.07);] py-[10px] text-white ${workDetail?.status === WORK_STATUS.COMPLETE
                            ? "bg-primary"
                            : "bg-checkedSuccess"
                            }  px-[22px] rounded-[4px] text-sm leading-5 cursor-pointer font-medium`}
                        onClick={() => {
                            handleUpdateStatus(
                                workDetail?.status === WORK_STATUS.COMPLETE
                                    ? WORK_STATUS.PENDING
                                    : WORK_STATUS.COMPLETE
                            );
                        }}
                    >
                        {workDetail?.status === WORK_STATUS.COMPLETE
                            ? "Chưa hoàn thành"
                            : "Hoàn thành"}
                    </div>
                </div>
                {/*  */}
                <Star
                    onClick={() =>
                        handleMarkImportantWork(!workDetail?.important)
                    }
                    color={`${workDetail?.important ? "#FFC700" : "#A2A2A2"}`}
                    height={26}
                    width={26}
                    fill={`${workDetail?.important ? "#FFC700" : "white"}`}
                />



            </footer>
            <AlertDialog
                open={deleteItem.open}
                handleClose={() =>
                    setDeleteItem({ open: false, comment_id: "" })
                }
                handleDelete={handleDeleteComment}
            />
            <Message
                message={message.title}
                openMessage={message.isOpen}
                severity={message.severity}
                closeMessage={() => {
                    setMessage({ title: "", isOpen: false });
                }}
            />
        </>
    );
};

export default memo(inject("workStore")(observer(WorkDetail)));
